var React = require('react');

function LuxeSelected (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"4","y":"4","width":"10","height":"10","rx":"5","fill":"black","key":0}),React.createElement("rect",{"x":"0.5","y":"0.5","width":"17","height":"17","rx":"8.5","stroke":"black","key":1})]);
}

LuxeSelected.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = LuxeSelected;

LuxeSelected.default = LuxeSelected;
